import { colors, typographyCss, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

type Props = {
  dataTestId: string;
  label: string;
  icon: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
};

const ItemContainer = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  margin-inline-end: 8px;
  height: fit-content;
  padding: 16px;
  width: fit-content;
  border-radius: 8px;
  background-color: ${({ isActive, theme }) => {
    const inactiveColor = cssThemedValue({ light: colors.pepper4, dark: colors.salt4 })({ theme });
    return isActive ? colors.wolt8 : inactiveColor;
  }};
  cursor: pointer;
`;

const ItemIconContainer = styled.div<{ isActive: boolean }>`
  width: 16px;
  height: 16px;
  margin-inline-end: 10px;

  svg {
    fill: ${({ isActive }) => {
      return isActive ? colors.wolt100 : cbSemanticCssVars.textPrimary;
    }};
  }
`;

const Label = styled.div`
  color: ${({ isActive }: { isActive: boolean }) => (isActive ? colors.wolt100 : 'inherit')};
  ${typographyCss.Body3()};
`;

const OpeningHoursTypeItem = ({ dataTestId, label, icon, isActive, onClick }: Props) => {
  return (
    <ItemContainer onClick={onClick} isActive={isActive}>
      <ItemIconContainer isActive={isActive}>{icon}</ItemIconContainer>

      <Label data-testid={dataTestId} isActive={isActive}>
        {label}
      </Label>
    </ItemContainer>
  );
};

export default OpeningHoursTypeItem;
